import { useModuleBEM } from "@b2bportal/core-themes";
import styles from "./styles.module.scss";

export type PriceBreakdownLineItemProps = {
  id?: string;
  label: string;
  value: string;
};

export const PriceBreakdownLineItem = ({
  id = "",
  label,
  value,
}: PriceBreakdownLineItemProps) => {
  const [, cn] = useModuleBEM(styles, "PriceBreakdownLineItem");

  return (
    <div className={cn("line-item-detail", { [id]: true })}>
      <div className={cn("line-item-label")}>{label}</div>
      <div className={cn("line-item-value")}>{value}</div>
    </div>
  );
};
